// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-wrapper {
  text-align: center;
  margin-bottom: 35px;
}
.good {
  background-color: #F9F9F9;
  padding: 18px 30px 22px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
}
.goodImage {
  width: 66px;
  height: 66px;
}
.goodTitle {
  font-size: 28px;
  font-weight: 800;
  line-height: 38px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 5px;
  cursor: pointer;
}
.goodAmount {
  font-size: 28px;
  font-weight: 800;
  line-height: 38px;
  color: #0EB2DA;
}
.goodAmount > span {
  font-weight: 600;
}
.selectTitle {
  font-size: 24px;
  line-height: 34px;
  font-weight: 600;
  color: #00000066;
}
.select {
  width: 100%;
  background-color: #F9F9F9;
  border-radius: 16px;
  border: 1px solid #00000008;
  height: unset !important;
  padding: 17px 20px !important;
}
.select img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 8px;
}
.select .rellpay-select-input {
  height: 24px;
  font-family: Darker Grotesque;
  font-weight: 800;
  font-size: 24px;
  line-height: 24px;
  color: #1F2128;
  padding: 0;
}
.select svg {
  width: 24px;
  height: 24px;
}
.tokenSkeleton {
  width: 65px;
  height: 80px !important;
  border-radius: 12px;
}
.amountSkeleton {
  width: 200px;
  height: 44px !important;
  margin-inline: auto;
  margin-bottom: 20px;
  border-radius: 12px;
}
.payAmount {
  font-size: 32px;
  font-weight: 600;
  line-height: 44px;
  text-align: center;
  margin-bottom: 20px;
  min-height: 44px;
}
.payAmount span {
  font-weight: 700;
}
.payment-title {
  font-size: 22px;
  text-align: center;
}
.payment-splitline {
  width: 100%;
  height: 1px;
  background-color: #f6f6f6;
  margin: 22px auto 20px;
}
.payment-tokens {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-auto-rows: 80px;
  gap: 10px;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  margin-bottom: 22px;
  min-height: 80px;
  max-height: 180px;
  flex-wrap: wrap;
  overflow-y: auto;
}
.payment-tokens-item {
  width: 65px;
  height: 80px;
  background-color: transparent;
  transition: background 0.25s;
  border-radius: 4px;
  cursor: pointer;
  flex-shrink: 0;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.payment-tokens-item:hover {
  background-color: #00000008;
}
.payment-tokens-item.actived {
  background-color: #00000008;
}
.payment-tokens-item.actived .amount {
  color: var(--text-primary);
}
.payment-tokens-logo {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.payment-tokens-price {
  color: #3F75FE;
  margin: 0 4px;
}
.paymentFooter .btn {
  width: 100%;
  height: 65px;
  border-radius: 16px;
}
.paymentFooter .btn span {
  font-family: Darker Grotesque;
  font-size: 20px;
  font-weight: 800;
  line-height: 28px;
}
.paymentFooter .powerBy {
  margin-top: 20px;
  font-family: Darker Grotesque;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  color: #00000080;
}
.paymentFooter .powerBy a {
  color: #25B2D4;
}
@media screen and (max-width: 452px) {
  .header-wrapper {
    margin-bottom: 18px;
  }
  .default-header {
    justify-content: center;
    gap: 5px;
    margin-bottom: 40px;
  }
  .default-header-icon {
    width: 28px;
    height: 28px;
  }
  .default-header-title {
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
  }
  .good {
    padding: 16px 12px 20px;
    gap: 12px;
  }
  .goodTitle {
    font-size: 20px;
    font-weight: 800;
    line-height: 28px;
  }
  .goodAmount {
    font-size: 24px;
    font-weight: 800;
    line-height: 32px;
  }
  .goodAmount > span {
    font-weight: 500;
  }
  .selectTitle {
    font-size: 20px;
    font-weight: 600;
    line-height: 1;
  }
  .select {
    padding: 12px !important;
  }
  .select .rellpay-select-input {
    font-size: 16px;
    line-height: 16px;
    font-weight: 800;
  }
  .select img,
  .select svg {
    width: 16px;
    height: 16px;
  }
  .payment-tokens {
    max-height: unset;
    height: calc(100vh - 548px);
  }
  .payAmount {
    font-size: 28px;
    font-weight: 800;
    line-height: 38px;
    margin-bottom: 18px;
  }
  .paymentFooter .btn {
    height: 48px;
    border-radius: 12px;
  }
  .paymentFooter .btn span {
    font-family: Darker Grotesque;
    font-size: 20px;
    font-weight: 700;
    line-height: 26px;
  }
  .paymentFooter .powerBy {
    margin-top: 8px;
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
  }
}
@media screen and (min-width: 453px) {
  .default-header {
    margin-bottom: 20px;
    justify-content: center;
    gap: 5px;
  }
  .default-header-icon {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }
  .default-header-title {
    font-size: 24px;
    line-height: 32px;
    font-weight: 600;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/default/style.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,mBAAA;AACJ;AAEA;EACI,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAAJ;AAGA;EACI,WAAA;EACA,YAAA;AADJ;AAIA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AAFJ;AAKA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAHJ;AADA;EAOQ,gBAAA;AAHR;AAOA;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AALJ;AAQA;EACI,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,2BAAA;EACA,wBAAA;EACA,6BAAA;AANJ;AAAA;EASQ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AANR;AANA;EAgBQ,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAPR;AAfA;EA0BQ,WAAA;EACA,YAAA;AARR;AAYA;EACI,WAAA;EACA,uBAAA;EACA,mBAAA;AAVJ;AAaA;EACI,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AAXJ;AAcA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAZJ;AAMA;EASQ,gBAAA;AAZR;AAgBA;EACI,eAAA;EACA,kBAAA;AAdJ;AAiBA;EACI,WAAA;EACA,WAAA;EACA,yBAAA;EACA,sBAAA;AAfJ;AAkBA;EACI,aAAA;EAEA,qCAAA;EACA,oBAAA;EACA,SAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAlBJ;AAoBI;EACI,WAAA;EACA,YAAA;EACA,6BAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAlBR;AAoBQ;EACI,2BAAA;AAlBZ;AAoBQ;EACI,2BAAA;AAlBZ;AAiBQ;EAIQ,0BAAA;AAlBhB;AAsBI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AApBR;AAsBI;EACI,cAAA;EACA,aAAA;AApBR;AAwBA;EAEQ,WAAA;EACA,YAAA;EACA,mBAAA;AAvBR;AAmBA;EAOY,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAvBZ;AAaA;EAeQ,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAzBR;AAIA;EAwBY,cAAA;AAzBZ;AA8BA;EACI;IACI,mBAAA;EA5BN;EA+BE;IACI,uBAAA;IACA,QAAA;IACA,mBAAA;EA7BN;EA+BM;IACI,WAAA;IACA,YAAA;EA7BV;EAgCM;IACI,eAAA;IACA,gBAAA;IACA,iBAAA;EA9BV;EAkCE;IACI,uBAAA;IACA,SAAA;EAhCN;EAmCE;IACI,eAAA;IACA,gBAAA;IACA,iBAAA;EAjCN;EAoCE;IACI,eAAA;IACA,gBAAA;IACA,iBAAA;EAlCN;EA+BE;IAMQ,gBAAA;EAlCV;EAsCE;IACI,eAAA;IACA,gBAAA;IACA,cAAA;EApCN;EAuCE;IACI,wBAAA;EArCN;EAoCE;IAIQ,eAAA;IACA,iBAAA;IACA,gBAAA;EArCV;EA+BE;;IAWQ,WAAA;IACA,YAAA;EAtCV;EA0CE;IACI,iBAAA;IACA,2BAAA;EAxCN;EA2CE;IACI,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,mBAAA;EAzCN;EA4CE;IAEQ,YAAA;IACA,mBAAA;EA3CV;EAwCE;IAMY,6BAAA;IACA,eAAA;IACA,gBAAA;IACA,iBAAA;EA3Cd;EAkCE;IAcQ,eAAA;IACA,eAAA;IACA,gBAAA;IACA,iBAAA;EA7CV;AACF;AAkDA;EACI;IACI,mBAAA;IACA,uBAAA;IACA,QAAA;EAhDN;EAkDM;IACI,WAAA;IACA,YAAA;IACA,kBAAA;EAhDV;EAmDM;IACI,eAAA;IACA,iBAAA;IACA,gBAAA;EAjDV;AACF","sourcesContent":[".header-wrapper {\n    text-align: center;\n    margin-bottom: 35px;\n}\n\n.good {\n    background-color: #F9F9F9;\n    padding: 18px 30px 22px;\n    border-radius: 16px;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.goodImage {\n    width: 66px;\n    height: 66px;\n}\n\n.goodTitle {\n    font-size: 28px;\n    font-weight: 800;\n    line-height: 38px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin-bottom: 5px;\n    cursor: pointer;\n}\n\n.goodAmount {\n    font-size: 28px;\n    font-weight: 800;\n    line-height: 38px;\n    color: #0EB2DA;\n\n    > span {\n        font-weight: 600;\n    }\n}\n\n.selectTitle {\n    font-size: 24px;\n    line-height: 34px;\n    font-weight: 600;\n    color: #00000066;\n}\n\n.select {\n    width: 100%;\n    background-color: #F9F9F9;\n    border-radius: 16px;\n    border: 1px solid #00000008;\n    height: unset !important;\n    padding: 17px 20px !important;\n\n    img {\n        width: 24px;\n        height: 24px;\n        border-radius: 50%;\n        margin-right: 8px;\n    }\n\n    .rellpay-select-input {\n        height: 24px;\n        font-family: Darker Grotesque;\n        font-weight: 800;\n        font-size: 24px;\n        line-height: 24px;\n        color: #1F2128;\n        padding: 0;\n    }\n\n    svg {\n        width: 24px;\n        height: 24px;\n    }\n}\n\n.tokenSkeleton {\n    width: 65px;\n    height: 80px !important;\n    border-radius: 12px;\n}\n\n.amountSkeleton {\n    width: 200px;\n    height: 44px !important;\n    margin-inline: auto;\n    margin-bottom: 20px;\n    border-radius: 12px;\n}\n\n.payAmount{\n    font-size: 32px;\n    font-weight: 600;\n    line-height: 44px;\n    text-align: center;\n    margin-bottom: 20px;\n    min-height: 44px;\n\n    span {\n        font-weight: 700;\n    }\n}\n\n.payment-title {\n    font-size: 22px;\n    text-align: center;\n}\n\n.payment-splitline {\n    width: 100%;\n    height: 1px;\n    background-color: #f6f6f6;\n    margin: 22px auto 20px\n}\n\n.payment-tokens {\n    display: grid;\n    grid-auto-rows: 80px;\n    grid-template-columns: repeat(5, 1fr);\n    grid-auto-rows: 80px;\n    gap: 10px;\n    overflow-y: auto;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 22px;\n    margin-bottom: 22px;\n    min-height: 80px;\n    max-height: 180px;\n    flex-wrap: wrap;\n    overflow-y: auto;\n\n    &-item {\n        width: 65px;\n        height: 80px;\n        background-color: transparent;\n        transition: background .25s;\n        border-radius: 4px;\n        cursor: pointer;\n        flex-shrink: 0;\n        border-radius: 12px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 4px;\n\n        &:hover {\n            background-color: #00000008;\n        }\n        &.actived {\n            background-color: #00000008;\n\n            .amount {\n                color: var(--text-primary);\n            }\n        }\n    }\n    &-logo {\n        width: 32px;\n        height: 32px;\n        border-radius: 50%;\n    }\n    &-price {\n        color: #3F75FE;\n        margin: 0 4px\n    }\n}\n\n.paymentFooter {\n    .btn {\n        width: 100%;\n        height: 65px;\n        border-radius: 16px;\n\n        span {\n            font-family: Darker Grotesque;\n            font-size: 20px;\n            font-weight: 800;\n            line-height: 28px;\n        }\n    }\n\n    .powerBy {\n        margin-top: 20px;\n        font-family: Darker Grotesque;\n        font-size: 18px;\n        font-weight: 400;\n        line-height: 24px;\n        text-align: center;\n        color: #00000080;\n\n        a {\n            color: #25B2D4;\n        }\n    }\n}\n\n@media screen and (max-width: 452px) {\n    .header-wrapper {\n        margin-bottom: 18px;\n    }\n\n    .default-header {\n        justify-content: center;\n        gap: 5px;\n        margin-bottom: 40px;\n\n        &-icon {\n            width: 28px;\n            height: 28px;\n        }\n\n        &-title {\n            font-size: 20px;\n            font-weight: 600;\n            line-height: 28px;\n        }\n    }\n\n    .good {\n        padding: 16px 12px 20px;\n        gap: 12px;\n    }\n\n    .goodTitle {\n        font-size: 20px;\n        font-weight: 800;\n        line-height: 28px;\n    }\n\n    .goodAmount {\n        font-size: 24px;\n        font-weight: 800;\n        line-height: 32px;\n\n        > span {\n            font-weight: 500;\n        }\n    }\n\n    .selectTitle {\n        font-size: 20px;\n        font-weight: 600;\n        line-height: 1;\n    }\n\n    .select {\n        padding: 12px !important;\n\n        .rellpay-select-input {\n            font-size: 16px;\n            line-height: 16px;\n            font-weight: 800;\n        }\n\n        img,\n        svg {\n            width: 16px;\n            height: 16px;\n        }\n    }\n\n    .payment-tokens {\n        max-height: unset;\n        height: calc(100vh - 548px);\n    }\n\n    .payAmount {\n        font-size: 28px;\n        font-weight: 800;\n        line-height: 38px;\n        margin-bottom: 18px;\n    }\n\n    .paymentFooter {\n        .btn {\n            height: 48px;\n            border-radius: 12px;\n    \n            span {\n                font-family: Darker Grotesque;\n                font-size: 20px;\n                font-weight: 700;\n                line-height: 26px;\n            }\n        }\n\n        .powerBy {\n            margin-top: 8px;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 19px;\n        }\n    }\n\n}\n\n@media screen and (min-width: 453px) {\n    .default-header {\n        margin-bottom: 20px;\n        justify-content: center;\n        gap: 5px;\n    \n        &-icon {\n            width: 30px;\n            height: 30px;\n            border-radius: 50%;\n        }\n    \n        &-title {\n            font-size: 24px;\n            line-height: 32px;\n            font-weight: 600;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
